<div class="header-bar">
  <h1>Manage Email Templates</h1>
</div>
<div class="content-container">
  <p-confirmDialog
    header="Confirmation"
    icon="fa-icon-circle"
    [style]="{ width: '425px' }"
    acceptLabel="Save"
    rejectLabel="Cancel"
  ></p-confirmDialog>
  <div class="ui-g-12">
    <div class="">
      <p-table
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="dataTableSettings.isPaginator"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="code">Code</th>
            <th pSortableColumn="title">Title</th>
            <th pSortableColumn="isSystem">Type</th>
            <th style="width: 120px"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>
              <span>{{ item.code }}</span>
            </td>
            <td>
              <span>{{ item.title }}</span>
            </td>
            <td>
              <span>{{ item.isSystem ? 'System' : 'User' }}</span>
            </td>
            <td>
              <button
                type="button"
                pButton
                [routerLink]="['/app/email-template-form', item.id]"
                icon="fa ui-icon-edit"
              ></button>
              <button
                type="button"
                pButton
                (click)="deleteEmailTemplate(item)"
                icon="fa ui-icon-trash"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="text-right">
        <button
          pButton
          [routerLink]="['/app/email-template-test']"
          type="button"
          label="Test Email Templates"
          style="margin-top: 10px"
          class="ui-button-tertiary"
        ></button>
        <button
          pButton
          [routerLink]="['/app/email-template-form', 0]"
          icon="fa ui-icon-add"
          type="button"
          label="Add Template"
          style="margin-top: 10px"
        ></button>
      </div>
    </div>
  </div>
</div>
